var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select-input',{attrs:{"label":_vm.label,"value-key":"value","label-value":"label","placeholder":_vm.placeholder,"size":_vm.size,"list":_vm.selectData,"required":_vm.required,"disabled":_vm.disabled},on:{"change":_vm.ticketUpdated},model:{value:(_vm.formData),callback:function ($$v) {_vm.formData=$$v},expression:"formData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }